(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/transaction-input.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/transaction-input.js');
'use strict';

const {
  useState,
  useEffect
} = React;
const {
  ReactButton: Button
} = svs.ui;
const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
const {
  Form
} = svs.ui.reactForm;
const AmountInput = svs.ui.reactFormInputs.AmountInput;
const {
  submitWithdrawFromTeam
} = svs.arena.pages.teams.helpers;
const {
  submitDeposit
} = svs.arena.shared.deposit.doDeposit;
const {
  setTeamBalance
} = svs.arena.store.teams.actions;
const {
  returnStatus
} = svs.arena.constants;
const errorMessageMaxDeposit = 'Observera att högsta insättningsbelopp är 25 000 kr.';
const errorMessageMaxWithdraw = 'Du kan högst ta ut ditt saldo i laget.';
const TransactionInput = _ref => {
  let {
    teamId,
    teamName,
    myTeamAmount,
    onSuccess = () => {}
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const [isDeposit, setIsDeposit] = useState(true);
  const [amount, setAmount] = React.useState('');
  const [maxAmount, setMaxAmount] = React.useState(25000);
  const [errorMessageMax, setErrorMessageMax] = React.useState(errorMessageMaxDeposit);
  const startDeposit = async amountIn => {
    svs.arena.logger.debug('Do deposit tranfer...', amountIn);
    const {
      status,
      error,
      memberBalance,
      syndicateBalance,
      playableAmount
    } = await submitDeposit(amountIn, teamId);
    if (status === returnStatus.SUCCESS) {
      svs.arena.logger.debug('Do deposit transfer success! status, syndicateBalance, playableAmount: ', status, syndicateBalance, playableAmount);
      dispatch(setTeamBalance({
        teamId,
        memberBalance,
        syndicateBalance,
        playableAmount
      }));
      onSuccess(memberBalance);
    } else if (status === returnStatus.ERROR) {
      svs.arena.logger.warn('Do deposit transfer NOT success! status, error: ', status, error);
    }
  };
  const startWithdraw = async amountIn => {
    svs.arena.logger.debug('Do withdrawal tranfer...', amountIn);
    const {
      status,
      error,
      memberBalance,
      syndicateBalance,
      playableAmount
    } = await submitWithdrawFromTeam({
      amount: amountIn,
      teamId,
      teamName
    });
    if (status === returnStatus.SUCCESS) {
      svs.arena.logger.debug('Do deposit transfer success! status, syndicateBalance, playableAmount: ', status, syndicateBalance, playableAmount);
      dispatch(setTeamBalance({
        teamId,
        memberBalance,
        syndicateBalance,
        playableAmount
      }));
    } else if (status !== returnStatus.CANCEL) {
      svs.arena.logger.warn('Do deposit transfer NOT success! status, error: ', status, error);
    }
  };
  useEffect(() => {
    svs.arena.logger.debug('TransactionInput, useEffect, isDeposit, myTeamAmount: ', isDeposit, myTeamAmount);
    setAmount('');
    setMaxAmount(isDeposit ? 25000 : parseInt(myTeamAmount, 10) || 0);
    setErrorMessageMax(isDeposit ? errorMessageMaxDeposit : errorMessageMaxWithdraw);
  }, [isDeposit, myTeamAmount]);
  const onSubmitHandler = async (e, formData, isValid) => {
    svs.arena.logger.debug('onSubmitHandler', isValid, formData);
    e.preventDefault();
    if (isValid && parseInt(amount, 10) > 0) {
      if (isDeposit) {
        startDeposit(amount);
      } else {
        startWithdraw(amount);
      }
    }
  };
  const onValidateHandler = (name, isValid, errorMessage) => {
    svs.arena.logger.debug('onValidateHandler:', name, isValid, errorMessage);
  };
  return React.createElement(React.Fragment, null, React.createElement("div", null, React.createElement("h4", {
    className: "h4 margin-top-1 margin-bottom-0"
  }, React.createElement("span", {
    className: "f-medium"
  }, " \xD6verf\xF6ring "))), React.createElement("div", {
    className: "align-center margin-top override"
  }, React.createElement(ItemsMenu, {
    branding: "arena",
    centered: true
    ,
    useScrollFaders: true,
    useScrollHelpers: svs.core.detect.formfactor.desktop()
  }, React.createElement(LinkItem, {
    Component: "a",
    gutter: 1,
    label: "Till lagkonto",
    onClick: () => setIsDeposit(true),
    selected: isDeposit
  }), React.createElement(LinkItem, {
    Component: "a",
    gutter: 1,
    label: "Fr\xE5n lagkonto ",
    onClick: () => setIsDeposit(false),
    selected: !isDeposit
  })), React.createElement("div", {
    className: "margin-xs-top-1"
  }, React.createElement(Form, {
    className: "js-syndicate-deposit-form align-left form-margin-override",
    isVertical: true,
    onSubmit: onSubmitHandler,
    onValidate: onValidateHandler
  }, React.createElement(AmountInput, {
    errorMessageDefault: "Felaktigt angivet belopp. Ange belopp i hela kronor.",
    errorMessageMax: errorMessageMax,
    label: "Ange belopp",
    max: maxAmount,
    min: 1,
    name: "amountInput",
    onChange: e => {
      setAmount(e.target.value);
    },
    type: "number",
    value: amount
  }), React.createElement(Button, {
    block: true,
    className: "margin-xs-top-1 js-submit-button",
    size: 200,
    transparent: true,
    type: "submit"
  }, isDeposit ? 'För över till lagkonto' : 'För över från lagkonto')))));
};
svs.arena.pages.teams.components.TransactionInput = TransactionInput;

 })(window);